import { Location, SearchResult } from '@rygen/rygen-ui/model';

export class LocationSearchResult extends SearchResult<Location> {
  constructor(opts?: Partial<LocationSearchResult>) {
    super(opts);

    if (opts?.content != null) {
      this.content = opts.content.map((val) => new Location(val));
    }
  }
}
